let page_schema = {
    "tiers": [
        {
            "name": "Sample Types",
            "type": "checkbox",
            "id": "sample-types",
            "class_name": "tags",
            "child_name": "sample-type",
            "options": [
                {
                    "name": "Bacteria",
                    "id": "bacteria"
                },
                {
                    "name": "Blood",
                    "id": "blood"
                },
                {
                    "name": "Cells & Tissue",
                    "id": "cells-and-tissue"
                },
                {
                    "name": "Feces",
                    "id": "feces"
                },
                {
                    "name": "FFPE & Sections",
                    "id": "ffpe-and-sections"
                },
                {
                    "name": "Fungus",
                    "id": "fungus"
                },
                {
                    "name": "Insect",
                    "id": "insect"
                },
                {
                    "name": "Plant",
                    "id": "plant"
                },
                {
                    "name": "Reaction Products & Aqueous Phase",
                    "id": "reaction-products-and-aqueous-phase"
                },
                {
                    "name": "Serum & Plasma",
                    "id": "serum-and-plasma"
                },
                {
                    "name": "Soil & Water",
                    "id": "soil-and-water"
                },
                {
                    "name": "Swabs & Saliva",
                    "id": "swabs-and-saliva"
                },
                {
                    "name": "Urine",
                    "id": "urine"
                },
                {
                    "name": "Virus",
                    "id": "virus"
                },
                {
                    "name": "Yeast",
                    "id": "yeast"
                }
            ]
        },
        {
            "name": "Features",
            "type": "checkbox",
            "id": "features",
            "class_name": "tags",
            "child_name": "feature",
            "options": [
                {
                    "name": "CE-IVD",
                    "id": "ce-ivd"
                },
                {
                    "name": "High-Throughput",
                    "id": "high-throughput"
                },
                {
                    "name": "Low Input",
                    "id": "low-input"
                },
                {
                    "name": "Lysis Tubes Included",
                    "id": "lysis-tubes-included"
                },
                {
                    "name": "DNase I Included",
                    "id": "dnase-i-included"
                },
                {
                    "name": "Proteinase K Included",
                    "id": "proteinase-k-included"
                }
            ]
        },
        {
            "name": "Formats",
            "type": "checkbox",
            "id": "formats",
            "class_name": "tags",
            "child_name": "format",
            "options": [
                {
                    "name": "Columns",
                    "id": "columns"
                },
                {
                    "name": "96-Well Plate",
                    "id": "96-well-plate"
                },
                {
                    "name": "Magnetic Beads",
                    "id": "magnetic-beads"
                }
            ]
        }
    ],
    "filters": [],
    "products": {
        "Quick-DNA/RNA Miniprep": {
            "title": "<i>Quick</i>-DNA/RNA Miniprep Kit",
            "catalogNumbers": "D7001",
            "description": "Provides a quick method for the isolation of high quality genomic DNA (up to 100 µg) and total RNA (up to 50 µg) from small amounts of cells and tissue without the use of phenol.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-miniprep",
            "navigation_image": "quick_dna_rna",
            "generalIndex": "2",
            "id": "quick-dna-rna-miniprep",
            "tags": [
                "bacteria",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Miniprep Plus Kit": {
            "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
            "catalogNumbers": "D7003, D7003T",
            "description": "Combines the <i>Quick</i>-DNA/RNA technology with DNA/RNA Shield, a unique preservation and lysis technology, and Proteinase K to enable easy, reliable isolation from biological samples including cells, solid tissue, and whole blood. ",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-miniprep-plus-kit",
            "navigation_image": "quick_dna_rna",
            "generalIndex": "3",
            "id": "quick-dna-rna-miniprep-plus-kit",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": [
                {
                    "filter": "insect",
                    "index": 2
                }
            ]
        },
        "Quick-DNA/RNA Microprep Plus Kit": {
            "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
            "catalogNumbers": "D7005, D7005T",
            "description": "Combines the <i>Quick</i>-DNA/RNA technology with DNA/RNA Shield and Proteinase K to enable easy, reliable isolation of ≤ 5 µg DNA and ≤ 10 µg RNA from biological samples including cells, solid tissue, and whole blood.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-microprep-plus-kit",
            "navigation_image": "quick_dna_rna",
            "generalIndex": "1",
            "id": "quick-dna-rna-microprep-plus-kit",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "low-input",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA MagBead": {
            "title": "<i>Quick</i>-DNA/RNA MagBead Kit",
            "catalogNumbers": "R2130, R2131",
            "description": "A high-throughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-magbead",
            "navigation_image": "quick_dna_rna_magbead",
            "generalIndex": "4",
            "id": "quick-dna-rna-magbead",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "proteinase-k-included",
                "magnetic-beads",
                "ffpe-and-sections"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Viral Kit": {
            "title": "<i>Quick</i>-DNA/RNA Viral Kit",
            "catalogNumbers": "D7020, D7021",
            "description": "A fast viral DNA/RNA purification kit for viral DNA and RNA from plasma, serum, cell culture media, cellular suspensions, urine, blood, saliva and any other biological samples stored in DNA/RNA Shield.",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-kit",
            "navigation_image": "quick_dna_rna_viral",
            "generalIndex": "5",
            "id": "quick-dna-rna-viral-kit",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "columns"
            ],
            "filters": [
                {
                    "filter": "serum-and-plasma",
                    "index": 2
                },
                {
                    "filter": "virus",
                    "index": 1
                }
            ]
        },
        "Quick-DNA/RNA Viral 96 Kit": {
            "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
            "catalogNumbers": "D7022, D7023",
            "description": "High-throughput (96-well) isolation of high-quality viral DNA and/or RNA from a wide range of biological sources. ",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-96-kit",
            "navigation_image": "quick_dna_rna_viral_96",
            "generalIndex": "6",
            "id": "quick-dna-rna-viral-96-kit",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "high-throughput",
                "96-well-plate"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Viral MagBead": {
            "title": "<i>Quick</i>-DNA/RNA Viral MagBead Kit",
            "catalogNumbers": "R2140, R2140-E, R2141, R2141-E",
            "description": "High-throughput, magnetic bead-based purification of viral DNA and/or RNA from plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, biopsies and swab and fecal samples stored in DNA/RNA Shield.",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-magbead",
            "navigation_image": "quick_dna_rna_viral_magbead",
            "generalIndex": "7",
            "id": "quick-dna-rna-viral-magbead",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "ce-ivd",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Load N' Go DNA/RNA Viral Kit": {
            "title": "Load N' Go DNA/RNA Viral Kit",
            "catalogNumbers": "R2143",
            "description": "Pre-loaded laboratory automation-ready reagent plates.",
            "handle": "/products/load-n-go-dna-rna-viral-kit",
            "navigation_image": "quick_dna_rna_viral_magbead",
            "generalIndex": "8",
            "id": "load-n-go-dna-rna-viral-kit",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Quick-DNA/RNA HT": {
            "title": "<i>Quick</i>-DNA/RNA HT Kit",
            "catalogNumbers": "R2150, R2150-E, R2151, R2151-E",
            "description": "Clinical, high-throughput, magnetic-bead-based purification of total nucleic acid (DNA/RNA) from any clinical sample (e.g., host, plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, swab, fecal and biopsies).",
            "handle": "/products/quick-dna-rna-ht",
            "navigation_image": "quick_dna_rna_viral_magbead",
            "generalIndex": "9",
            "id": "quick-dna-rna-ht",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "ce-ivd",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": [
                {
                    "filter": "swabs-and-saliva",
                    "index": 1
                },
                {
                    "filter": "virus",
                    "index": 2
                }
            ]
        },
        "ZymoBIOMICS DNA/RNA Miniprep Kit": {
            "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
            "catalogNumbers": "R2002",
            "description": "Designed for purifying DNA and RNA from a wide array of sample inputs (e.g. feces, soil, plant, water, and biofilms). Ready for RT-PCR, arrays, sequencing, microbiome or metagenome analyses. ",
            "handle": "/collections/zymobiomics-dna-rna-kits/products/zymobiomics-dna-rna-miniprep-kit",
            "navigation_image": "microbiomics",
            "generalIndex": "10",
            "id": "zymobiomics-dna-rna-miniprep-kit",
            "tags": [
                "bacteria",
                "feces",
                "fungus",
                "plant",
                "soil-and-water",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "lysis-tubes-included",
                "dnase-i-included",
                "columns"
            ],
            "filters": [
                {
                    "filter": "bacteria",
                    "index": 1
                },
                {
                    "filter": "feces",
                    "index": 1
                },
                {
                    "filter": "fungus",
                    "index": 1
                },
                {
                    "filter": "plant",
                    "index": 1
                },
                {
                    "filter": "yeast",
                    "index": 1
                }
            ]
        },
        "ZymoBIOMICS MagBead DNA/RNA": {
            "title": "ZymoBIOMICS MagBead DNA/RNA Kit",
            "catalogNumbers": "R2135, R2136",
            "description": "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
            "handle": "/collections/zymobiomics-dna-rna-kits/products/zymobiomics-magbead-dna-rna",
            "navigation_image": "high_throughput_magbead_microbiomics",
            "generalIndex": "11",
            "id": "zymobiomics-magbead-dna-rna",
            "tags": [
                "bacteria",
                "feces",
                "fungus",
                "plant",
                "soil-and-water",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": [
                // {
                //     "filter": "bacteria",
                //     "index": 2
                // },
                {
                    "filter": "feces",
                    "index": 2
                },
                {
                    "filter": "fungus",
                    "index": 2
                },
                {
                    "filter": "plant",
                    "index": 2
                },
                {
                    "filter": "yeast",
                    "index": 2
                }
            ]
        },
        "Quick-DNA/RNA Pathogen Miniprep": {
            "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep Kit",
            "catalogNumbers": "R1042, R1043",
            "description": "A spin-column based purification of pathogen DNA and RNA from a wide variety of vectors and tissue types transported and stored in DNA/RNA Shield.",
            "handle": "/collections/quick-dna-rna-pathogen-kits/products/quick-dna-rna-pathogen-miniprep",
            "navigation_image": "pathogen",
            "generalIndex": "12",
            "id": "quick-dna-rna-pathogen-miniprep",
            "tags": [
                "bacteria",
                "cells-and-tissue",
                "insect",
                "swabs-and-saliva",
                "virus",
                "proteinase-k-included",
                "columns"
            ],
            "filters": [
                {
                    "filter": "insect",
                    "index": 1
                }
            ]
        },
        "Quick-DNA/RNA Pathogen MagBead": {
            "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead Kit",
            "catalogNumbers": "R2145, R2146",
            "description": "High-throughput, magnetic bead-based purification of pathogen (virus, bacteria, protozoa) DNA and RNA from a wide variety of vectors (mosquitoes, fleas, ticks, etc.)",
            "handle": "/collections/quick-dna-rna-pathogen-kits/products/quick-dna-rna-pathogen-magbead",
            "navigation_image": "pathogen_magbead",
            "generalIndex": "13",
            "id": "quick-dna-rna-pathogen-magbead",
            "tags": [
                "bacteria",
                "cells-and-tissue",
                "insect",
                "swabs-and-saliva",
                "virus",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Blood Tube Kit": {
            "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
            "catalogNumbers": "R1151",
            "description": "Co-purify DNA and RNA from the DNA/RNA Shield Blood Collection Tube.",
            "handle": "/products/quick-dna-rna-blood-tube-kit",
            "navigation_image": "blood_tube",
            "generalIndex": "14",
            "id": "quick-dna-rna-blood-tube-kit",
            "tags": [
                "blood",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": [
                {
                    "filter": "blood",
                    "index": 1
                }
            ]
        },
        "Quick-cfDNA/cfRNA Serum & Plasma Kit": {
            "title": "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
            "catalogNumbers": "R1072",
            "description": "Simple and efficient preparation of all circulating cell-free DNA and RNA from serum, plasma, and other biological fluids without toxic phenol-chloroform or cumbersome protein precipitation and removal steps.",
            "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
            "navigation_image": "serum_and_plasma",
            "generalIndex": "15",
            "id": "quick-cfdna-rna-serum-plasma-kit",
            "tags": [
                "serum-and-plasma",
                "urine",
                "proteinase-k-included",
                "columns"
            ],
            "filters": [
                {
                    "filter": "serum-and-plasma",
                    "index": 1
                }
            ]
        },
        "Quick-DNA/RNA FFPE Miniprep Kit": {
            "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
            "catalogNumbers": "R1009",
            "description": "A simple and reliable method for total nucleic acid isolation (DNA & RNA) from the same formalin-fixed, paraffin embedded (FFPE) tissue sample.",
            "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
            "navigation_image": "ffpe_section",
            "generalIndex": "16",
            "id": "quick-dna-rna-ffpe-miniprep-kit",
            "tags": [
                "ffpe-and-sections",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": []
        },
        "Oligo Clean & Concentrator": {
            "title": "Oligo Clean & Concentrator",
            "catalogNumbers": "D4060, D4061",
            "description": "Provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥ 16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
            "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator",
            "navigation_image": "oligo_clean",
            "generalIndex": "18",
            "id": "oligo-clean-concentrator",
            "tags": [
                "reaction-products-and-aqueous-phase",
                "columns"
            ],
            "filters": []
        },
        "ZR-96 Oligo Clean & Concentrator": {
            "title": "ZR-96 Oligo Clean & Concentrator Kit",
            "catalogNumbers": "D4062, D4063",
            "description": "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l.",
            "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator-zr96",
            "navigation_image": "high_throughput_96_well_oligo_clean",
            "generalIndex": "19",
            "id": "oligo-clean-concentrator-zr96",
            "tags": [
                "reaction-products-and-aqueous-phase",
                "high-throughput",
                "96-well-plate"
            ],
            "filters": []
        },
        "ssDNA/RNA Clean & Concentrator": {
            "title": "ssDNA/RNA Clean & Concentrator",
            "catalogNumbers": "D7010, D7011",
            "description": "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
            "handle": "/products/ssdna-rna-clean-concentrator",
            "navigation_image": "ssdna_rna_clean",
            "generalIndex": "20",
            "id": "ssdna-rna-clean-concentrator",
            "tags": [
                "reaction-products-and-aqueous-phase",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Water Kit": {
            "title": "<i>Quick</i>-DNA/RNA Water Kit",
            "catalogNumbers": "R2044",
            "description": "The <i>Quick</i>-DNA/RNA Water Kit efficiently isolates inhibitor-free nucleic acids from large water samples, ideal for sensitive applications like ddPCR, RT-qPCR, and NGS.",
            "handle": "/products/quick-dna-rna-water-kit",
            "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna_rna_co_extraction/R2044.webp",
            "generalIndex": "17",
            "id": "quick-dna-rna-water-kit",
            "tags": [
                "bacteria",
                "soil-and-water",
                "virus",
                "lysis-tubes-included",
                "dnase-i-included",
                "columns"
            ],
            "filters": []
        }
    }
}